import { useEffect, useState } from 'react';

export default function useIsTallEnough(minHeight = 820) {
  const [isTallEnough, setIsTallEnough] = useState(window.innerHeight >= minHeight);

  useEffect(() => {
    const handleResize = () => {
      setIsTallEnough(window.innerHeight >= minHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [minHeight]);

  return isTallEnough;
}
